import { identity } from "@thi.ng/compose";
import { $$reduce } from "../reduce";
import { count } from "./count";
import { groupByMap } from "./group-by-map";
export function frequencies(...args) {
    return ($$reduce(frequencies, args) ||
        groupByMap({ key: args[0] || identity, group: count() }));
}
